import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from '../providers/auth.provider';
import { CONST } from '../providers/const';
import { UtilitiesService } from '../providers/utilities.provider';

@Injectable()
export class LoginRouteLogged implements CanActivate {
    public isLoadingLogout = false;
    constructor(private router: Router, private authService: AuthService) { }

    canActivate() {
        let token = this.authService.getToken();
        if (token) {
            let ind = localStorage.getItem(CONST.LOCALSTORAGE.switchFlag)
            if (!ind) {
                return true;
            } else {
                this.router.navigate(['/portal'], { replaceUrl: true }).then(res => {
                    localStorage.removeItem(CONST.LOCALSTORAGE.switchFlag)
                });
                return false;
            }
        } else {
          this.isLoadingLogout = true;
          this.authService.logout()
          .finally(() => { 
            this.isLoadingLogout = false; 
            this.authService.clearSession();
            this.router.navigate(['/public/home']);
          })
          .then(() => {});
            return false;
        }
    }
}

@Injectable()
export class StepRouteLogged implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }
    canActivate() {
        let user = this.authService.getUserInfo();
        let step = user.step;

        if (+step == CONST.PROFILE_STEP.complete) {
            return true;
        } else {
            this.router.navigate(['/portal/profile']);
            return false;
        }
    }
}

@Injectable()
export class NewAccountClubStaffRoute implements CanActivate {
    constructor(private router: Router) { }
    canActivate() {
        let data = localStorage.getItem(CONST.LOCALSTORAGE.infoSignUp);
        if (data) {
            return true;
        } else {
            this.router.navigate(['/public/signup/club']);
            return false;
        }
    }
}

@Injectable()
export class NewAccountStfStaffRoute implements CanActivate {
    constructor(private router: Router) { }
    canActivate() {
        let data = localStorage.getItem(CONST.LOCALSTORAGE.infoSignUp);
        if (data) {
            return true;
        } else {
            this.router.navigate(['/public/signup/stf']);
            return false;
        }
    }
}

@Injectable()
export class NewAccountScoutRoute implements CanActivate {
    constructor(private router: Router) { }
    canActivate() {
        let data = localStorage.getItem(CONST.LOCALSTORAGE.infoSignUp);
        if (data) {
            return true;
        } else {
            this.router.navigate(['/public/signup/talent-scout']);
            return false;
        }
    }
}


@Injectable()
export class LoginRouteAdmin implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService
    ) { }

    async canActivate() {
        let user = this.authService.getUserInfo();
        let token = this.authService.getToken();
        let role = user.role

        if (token && role && role == CONST.ROLES.admin) {
            return true;
        } else {
            this.router.navigate(['/public/home']);
            return false;
        }
    }
}

@Injectable()
export class PortalRouteLogged implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService,
        private utils: UtilitiesService
    ) { }

    canActivate() {
        let token = this.authService.getToken();

        if (token) {
            this.router.navigate(['/portal']).then(res => {
                this.utils.validateProfilePicture.emit(true)
            });
            return false;
        } else {
            return true;
        }
    }
}


/** Guards para validar el rol en cada vista */

@Injectable()
export class AthleteRouteLogged implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService,
        private utils: UtilitiesService
    ) { }

    canActivate() {
        let user = this.authService.getUserInfo();
        let role = user && user.role ? user.role : null

        if (role && role == CONST.ROLES.athlete) {
            return true;
        } else {
            this.router.navigate(['/portal']).then(res => {
                this.utils.validateProfilePicture.emit(true)
            });
            return false;
        }
    }
}


@Injectable()
export class ParentRouteLogged implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService,
        private utils: UtilitiesService
    ) { }

    canActivate() {
        let user = this.authService.getUserInfo();
        let role = user && user.role ? user.role : null

        if (role && role == CONST.ROLES.parent) {
            return true;
        } else {
            this.router.navigate(['/portal']).then(res => {
                this.utils.validateProfilePicture.emit(true)
            });
            return false;
        }
    }
}

@Injectable()
export class CLubStaffRouteLogged implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService,
        private utils: UtilitiesService
    ) { }

    canActivate() {
        let user = this.authService.getUserInfo();
        let role = user && user.role ? user.role : null

        if (role && role == CONST.ROLES.club_staff) {
            return true;
        } else {
            this.router.navigate(['/portal']).then(res => {
                this.utils.validateProfilePicture.emit(true)
            });
            return false;
        }
    }
}

@Injectable()
export class ScoutRouteLogged implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService,
        private utils: UtilitiesService
    ) { }

    canActivate() {
        let user = this.authService.getUserInfo();
        let role = user && user.role ? user.role : null

        if (role && role == CONST.ROLES.scout) {
            return true;
        } else {
            this.router.navigate(['/portal']).then(res => {
                this.utils.validateProfilePicture.emit(true)
            });
            return false;
        }
    }
}

@Injectable()
export class ScoutClubStaffRouteLogged implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService,
        private utils: UtilitiesService
    ) { }

    canActivate() {
        let user = this.authService.getUserInfo();
        let role = user && user.role ? user.role : null

        if (role && (role == CONST.ROLES.scout || role == CONST.ROLES.club_staff)) {
            return true;
        } else {
            this.router.navigate(['/portal']).then(res => {
                this.utils.validateProfilePicture.emit(true)
            });
            return false;
        }
    }
}

@Injectable()
export class StfStaffRouteLogged implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService,
        private utils: UtilitiesService
    ) { }

    canActivate() {
        let user = this.authService.getUserInfo();
        let role = user && user.role ? user.role : null

        if (role && role == CONST.ROLES.stf_staff) {
            return true;
        } else {
            this.router.navigate(['/portal']).then(res => {
                this.utils.validateProfilePicture.emit(true)
            });
            return false;
        }
    }
}
